import { Injectable } from '@angular/core';
import { OauthAdapter } from './oauth.adapter';

@Injectable({
  providedIn: 'root',
})
export class QuestiAdapter extends OauthAdapter {
  protected provider = 'questi';

  constructor() {
    super();
  }
}
